import { Navbar, NavigationIcon } from '@frontend/components/mobile';
import { LuHouse, LuRibbon, LuUser } from 'react-icons/lu';
import { TbActivity } from 'react-icons/tb';
import { FormattedMessage } from 'react-intl';

import useDefaultFooter from './default-footer.controller';

export interface DefaultFooterProps {
    disabled?: string[];
}

const DefaultFooter = (props: DefaultFooterProps) => {
    const viewProps = useDefaultFooter(props);
    return (
        <Navbar>
            <NavigationIcon
                text={
                    <FormattedMessage
                        id='mobile.footer.home'
                        description='The home button on the mobile footer'
                        defaultMessage='Home'
                    />
                }
                icon={LuHouse}
                link={`${viewProps.currentApp ? `${viewProps.currentApp}/` : ''}home`}
                disabled={viewProps.homeDisabled}
            />
            <NavigationIcon
                text={
                    <FormattedMessage
                        id='mobile.footer.activity'
                        description='The Activity button on the mobile footer'
                        defaultMessage='Activity'
                    />
                }
                icon={TbActivity}
                link={`${viewProps.currentApp}/activities`}
                disabled={viewProps.activitiesDisabled}
            />
            <NavigationIcon
                text={
                    <FormattedMessage
                        id='mobile-nivaliz.footer.deceased'
                        description='The Deceased button on the mobile-nivaliz footer'
                        defaultMessage='Deceased'
                    />
                }
                icon={LuRibbon}
                link={`${viewProps.currentApp}/deceased`}
                disabled={viewProps.deceasedDisabled}
            />
            <NavigationIcon
                text={
                    <FormattedMessage
                        id='mobile.footer.profile'
                        description='The Profile button on the mobile footer'
                        defaultMessage='Profile'
                    />
                }
                icon={LuUser}
                link='profile'
                disabled={viewProps.profileDisabled}
            />
        </Navbar>
    );
};

export default DefaultFooter;
